import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Text = makeShortcode("Text");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<Text sx={{
      fontSize: [4, 5, 6],
      fontWeight: `bold`,
      color: `heading`
    }} mdxType="Text">
  Hi.
</Text>
<p>{`Hi, I'm Ky — an AI/ML Software Engineer, A Tech Lead currently based in Seoul, South Korea.`}</p>
<p>{`This is my personal blog where I document what I’ve learned, reflect on real-world challenges, and share insights across software engineering, AI systems, and personal growth.`}<br parentName="p"></br>{`
`}{`It’s not only a knowledge base for myself, but also a space to connect with others who are on the same journey of building, learning, and evolving.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      